<template>
  <div>
    <el-row>
      <el-col>
        <el-button size="medium" style="margin: 20px 0 20px 0" @click="chengeProduct">指定采购</el-button>
        <el-button size="medium" style="margin: 20px 0 20px 0" @click="notNeedShop">无需购买</el-button>
        <el-button size="medium" style="margin: 20px 0 20px 0" @click="transition">批量转换</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" border @selection-change="handleSelectionChange" :row-class-name="tableRowClassName">
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column prop="N" label="产品名称"></el-table-column>
          <el-table-column prop="C" label="产品编号"></el-table-column>
          <el-table-column prop="U" label="单位"></el-table-column>
          <el-table-column prop="T" label="数量"></el-table-column>
          <el-table-column prop="W" label="库存数量"></el-table-column>
          <el-table-column prop="SS" label="安全库存量"></el-table-column>
          <el-table-column label="建议采买数">
            <template slot-scope="scope">
              <el-input v-model="scope.row.SUGGEST"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="M" label="备注"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="notNeed(scope.row)" type="text">无需购买</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-dialog title="选择订单信息" center :visible.sync="addFormVisible" width="600px">
          <el-form size="small" :model="addForm" ref="addForm" :rules="rules">
            <el-form-item label="供应商：" :label-width="formLableWidth" prop="customer" v-show="actionFlag == 1">
              <el-select filterable v-model="addForm.customer" placeholder="请选择供应商" clearable style="width:80%">
                <el-option v-for="item in customers" :key="item.SUPPLIER_ID" :label="item.AB_NAME" :value="item.SUPPLIER_ID"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="送货日期：" :label-width="formLableWidth" prop="SEND_DAY">
              <el-date-picker v-model="addForm.SEND_DAY" clearable type="date" placeholder="选择日期" value-format="yyyy-MM-dd" style="width:80%">
              </el-date-picker>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="close">取 消</el-button>
            <el-button size="small" @click="submitAdd('addForm')">确 定</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { haveGYSFun } from 'api/shopOrderManage';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      tableData: [],
      checkedArray: [],
      addFormVisible: false,
      addForm: {},
      customers: [],
      rules: {
        customer: [
          { required: true, message: '请选择供应商', trigger: 'blur' },
        ],
        SEND_DAY: [
          { required: true, message: '请选择送货日期', trigger: 'blur' },
        ],
      },
      formLableWidth: '100px',
      notNeedArr: [],
      actionFlag: 1,
      currentOrderFlag: sessionStorage.getItem('currentOrderFlag'),
      groupID: sessionStorage.getItem('GROUP_ID'),
    };
  },
  created() {
    this.queryTable();
    this.queryCustomer();
    this.addForm.SEND_DAY = sessionStorage.getItem('sendDay');
  },
  methods: {
    queryTable() {
      const params = {
        SERVICE_ID: '10022',
        OTYPE: 1,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
        CATALOG_ID: Number(sessionStorage.getItem('kindId')),
        SEND_DAY: sessionStorage.getItem('sendDay'),
      };
      if (this.currentOrderFlag == 1) {
        params.IS_SUPPLIER_CLIENT = 1;
      }
      if (sessionStorage.getItem('GROUP_ID') != '') {
        params.GROUP_ID = sessionStorage.getItem('GROUP_ID');
      }
      this.loading = true;
      http.post(params).then((result) => {
        if (result[0].FLAG == 0) {
          if (result[0].DATA.length !== 0) {
            this.loadSearch = false;
            this.tableData = result[0].DATA[0].DATA.map((item) => {
              if (item.T + item.SS - item.W <= 0) {
                return Object.assign(item, { SUGGEST: 0 });
              }
              return Object.assign(item, { SUGGEST: item.T - item.W + Number(item.SS) });
            });
            this.name = result[0].COMPANY_NAME;
          } else {
            this.tableData = [];
            this.loadSearch = false;
            this.$message.show({
              text: '暂无数据',
              type: 'warning',
            });
          }
        } else {
          this.loadSearch = false;
          this.$confirm('您选择日期的订单中存在未分类的产品，请先进行分类?', '提示', {
            confirmButtonText: '立即前往',
            type: 'warning',
            showClose: false,
            showCancelButton: false,
          }).then(() => {
            this.$router.push({ name: 'PurchaseMatchProduct' });
          });
        }
      }).catch((error) => {
        this.loading = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleSelectionChange(val) {
      this.checkedArray = val;
    },
    chengeProduct() {
      this.actionFlag = 1;
      this.addForm = {
        SEND_DAY: this.addForm.SEND_DAY,
      };
      if (this.checkedArray.length !== 0) {
        this.submitArr = [];
        this.submitArr = this.checkedArray.map((item) => ({ PRODUCT_CODE: item.C, PRODUCT_COUNT: item.SUGGEST }));
        const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
        const flag = this.submitArr.find((item) => {
          if (!reg.test(item.PRODUCT_COUNT)) {
            return true;
          }
        });
        if (flag) {
          this.$message.show({ text: '请输入正数建议采买数', type: 'warning' });
          return false;
        }
        this.addFormVisible = true;
      } else {
        this.$message.show({ text: '请选择产品', type: 'warning' });
      }
    },
    queryCustomer() {
      haveGYSFun().then((result) => {
        if (result.length !== 0) {
          this.companys = result[0].list;
          this.customers = result[0].list;
        } else {
          this.companys = [];
          this.customers = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    close() {
      this.addFormVisible = false;
    },
    submitAdd() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10052',
            OTYPE: 1,
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            GYS_ID: Number(sessionStorage.getItem('tcId')),
            SEND_DAY: this.addForm.SEND_DAY,
            SALE_ORDER_DAY: sessionStorage.getItem('sendDay'),
            PRODUCT_ARRAY: this.submitArr,
          };
          if (this.groupID) {
            params.GROUP_ID = this.groupID;
          }
          if (this.actionFlag == 1) {
            params.SUPPLIER_ID = this.addForm.customer;
          }
          if (this.currentOrderFlag == 1) {
            params.IS_SUPPLIER_CLIENT = 1;
          }
          http.post(params).then((result) => {
            this.addFormVisible = false;
            this.$message.show({ text: '移动成功', type: 'success' });
            this.queryTable();
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
        } finally {
          document.body.style.cursor = 'default';
        }
      }
    },
    showCount(row) {
      if (row.T - row.W <= 0) {
        return 0;
      }
      return row.T - row.W;
    },
    notNeed(row) {
      const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      if (!reg.test(row.SUGGEST)) {
        this.$message.show({ text: '请输入正数采买数', type: 'warning' });
        return false;
      }
      this.notNeedArr.push(row.C);
      this.sumitNotNeed();
    },
    notNeedShop() {
      if (this.checkedArray.length !== 0) {
        this.submitArr = [];
        const tmpArr = this.checkedArray.map((item) => ({ PRODUCT_CODE: item.C }));
        tmpArr.forEach((item, index) => {
          this.notNeedArr.push(item.PRODUCT_CODE);
        });
        this.sumitNotNeed();
      } else {
        this.$message.show({ text: '请选择产品', type: 'warning' });
      }
    },
    sumitNotNeed() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10052',
            OTYPE: 2,
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            GYS_ID: Number(sessionStorage.getItem('tcId')),
            SALE_ORDER_DAY: sessionStorage.getItem('sendDay'),
            PRODUCT_ARRAY: this.notNeedArr,
          };
          if (this.currentOrderFlag == 1) {
            params.IS_SUPPLIER_CLIENT = 1;
          }
          http.post(params).then((result) => {
            this.$message.show({ text: '标记成功', type: 'success' });
            this.queryTable();
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
        } finally {
          document.body.style.cursor = 'default';
        }
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.SUGGEST == 0) {
        return 'success-row';
      }
      return '';
    },
    transition() {
      this.actionFlag = 0;
      this.addForm = {
        SEND_DAY: this.addForm.SEND_DAY,
      };
      if (this.checkedArray.length !== 0) {
        this.addFormVisible = true;
        this.submitArr = [];
        this.submitArr = this.checkedArray.map((item) => ({ PRODUCT_CODE: item.C, PRODUCT_COUNT: item.SUGGEST }));
      } else {
        this.$message.show({ text: '请选择产品', type: 'warning' });
      }
    },
  },
};
</script>
<style>
.el-table .success-row {
  background: #addf93;
}

.el-table .warning-row {
  background: oldlace;
}
</style>



// WEBPACK FOOTER //
// src/components/sendDocument/totalPurchase.vue